import React, { useMemo } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { defaultGridHeight } from './utils';
import { useIncreasedMonthlyPCardContext } from 'contexts/CategoryInsightsKpi/IncreasedMonthlyPCardProvider';
import AgGridTable from 'components/AGGridTable/AgGridTable';

const IncreasedMonthlyPCardExplore = () => {
	const { gridData } = useIncreasedMonthlyPCardContext();
	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`P-card spend increase seen month over month.`}
				</AnalysisDescription>
				<TableContainer>
					<AgGridTable gridOptions={gridData} gridStyle={gridStyle} />
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default IncreasedMonthlyPCardExplore;
